module.exports = __webpack_public_path__ + "img/group-figure6.b9ea827a.svg";